export const excepcionesKeys = {
  all: ['excepciones'] as const,
  lists: () => [...excepcionesKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...excepcionesKeys.lists(), filters] as const,
  // Stats cuelgan de lists() para que invalidar el listado también refresque los KPIs.
  stats: (filters: Record<string, unknown>) =>
    [...excepcionesKeys.lists(), 'stats', filters] as const,
  details: () => [...excepcionesKeys.all, 'detail'] as const,
  detail: (id: number) => [...excepcionesKeys.details(), id] as const,
};
